import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
import * as exportImportDispatcher from '../../../../_common/platform/ts/exportImportDispatcher';

import WorkspacesExportField, {
    WORKSPACES_EXPORT_ID,
    WorkspacesExportStore
} from '../../tsx/exportImport/WorkspacesExport';

import {
    ENTITY_MODEL_EXPORT_ID,
    EntityModelExport,
    EntityModelExportStore
} from '../../tsx/exportImport/EntityModelExportImport';

import {
    DATA_PERMISSION_EXPORT_ID,
    DataPermission_Export,
    DataPermissionExportStore
} from '../../tsx/exportImport/DataPermission_ExpImp';

import WorkspacesImportField from '../../tsx/exportImport/WorkspacesImport';

import ResourceExportField from '../../tsx/exportImport/ResourcesExport';
import ResourceImportField from '../../tsx/exportImport/ResourcesImport';

import TemplatesExportField from '../../tsx/exportImport/TemplatesExport';
import TemplatesImportField from '../../tsx/exportImport/TemplatesImport';

import ThemesExportField, { THEMES_EXPORT_ID, ThemesExportStore } from '../../tsx/exportImport/ThemesExport';

import AppSettingsExportField from '../../tsx/exportImport/AppSettingsExport';
import SettingsImport from '../../tsx/exportImport/AppSettingsImport';

import { SqlTestCasesModelExport } from '../../tsx/exportImport/SqlTestCasesExportImport';

import { UserGroupsExport } from './UserGroupsExport';
import { UserGroupsImport } from './UserGroupsImport';

function registerEntityModels(glob: IGlob) {
    exportImportDispatcher.register({
        ComponentExport: EntityModelExport,
        componentOptionsExport: { entityModel: 1 },
        ComponentImport: SettingsImport,
        id: ENTITY_MODEL_EXPORT_ID,
        title: 'Entity Models',

        exportStore: new EntityModelExportStore(glob),

        export: (options) => {
            if (options == null) {
                return null;
            }

            return {
                entityModel: {
                    dataSources: options.dataSources
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Entity Model is not specified.\n');
            }

            return errorList;
        }
        //priority: 1
    });
}

function registerDataPermission(glob: IGlob) {
    exportImportDispatcher.register({
        ComponentExport: DataPermission_Export,
        componentOptionsExport: { dataPermission: 1 },
        ComponentImport: SettingsImport,
        id: DATA_PERMISSION_EXPORT_ID,
        title: 'Data Permissions for Entity Models',

        exportStore: new DataPermissionExportStore(glob),

        export: (options) => {
            if (options == null) {
                return null;
            }

            return {
                dataPermission: {
                    dataSources: options.dataSources
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Data Model Permission is not specified.\n');
            }

            return errorList;
        }
        //priority: 2
    });
}

function registerWorkspaces(glob: IGlob) {
    exportImportDispatcher.register({
        ComponentExport: WorkspacesExportField,
        componentOptionsExport: {},
        ComponentImport: WorkspacesImportField,
        id: WORKSPACES_EXPORT_ID,
        title: 'Workspaces and Folders',

        exportStore: new WorkspacesExportStore(glob),

        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                workspaces: {
                    subfolders: parseArr(options.dirs),
                    ids: parseArr(options.workspaces)
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.dirid == undefined) {
                errorList.push(' - Workspace Target Folder is not specified.\n');
            }

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Workspace(s) is not specified.\n');
            }

            return errorList;
        }
        //priority: 3
    });
}

function registerThemes(glob: IGlob) {
    exportImportDispatcher.register({
        ComponentExport: ThemesExportField,
        componentOptionsExport: {
            hideCustom: true
        },
        ComponentImport: SettingsImport,
        id: THEMES_EXPORT_ID,
        title: 'Themes',

        exportStore: new ThemesExportStore(glob),

        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                themes: {
                    ids: options.themes
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Theme(s) is not specified.\n');
            }

            return errorList;
        }
        //priority: 4
    });
}

function parseArr(arr) {
    return _.map(arr, (key: any) => {
        if (typeof key === 'number') {
            return key;
        }

        try {
            let retValue = parseInt(key, 10);

            if (isNaN(retValue) === false) {
                return retValue;
            }
        } catch (e) {}

        return key;
    });
}

function registerResources() {
    exportImportDispatcher.register({
        ComponentExport: ResourceExportField,
        componentOptionsExport: {},
        ComponentImport: ResourceImportField,
        id: 'resources',
        title: 'Resources',
        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                resources: {
                    subfolders: parseArr(options.dirs),
                    ids: parseArr(options.items)
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.dirid == undefined) {
                errorList.push(' - Resource Target Folder is not specified.\n');
            }

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Resource Item(s) is not specified.\n');
            }

            if (options == null || _.isEmpty(options.listResFiles)) {
                errorList.push(' - Resource Data File(s) is not specified.\n');
            }

            if (options?.listResFiles != null && options?.keyList != null) {
                _.each(options.keyList, function (item: any) {
                    if (options.listResFiles[item.data.GUID] == null) {
                        errorList.push(' - Resource Data file: ' + item.data.GUID + ' is missed.\n');
                    }
                });
            }

            return errorList;
        }
        //priority: 5
    });
}

function registerTemplates() {
    exportImportDispatcher.register({
        ComponentExport: TemplatesExportField,
        componentOptionsExport: {},
        ComponentImport: TemplatesImportField,
        id: 'templates',
        title: 'Widgets',
        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                templates: {
                    subfolders: parseArr(options.dirs),
                    ids: parseArr(options.templates)
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.dirid == undefined) {
                errorList.push(' - Widget Target Folder is not specified.\n');
            }

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - Widget(s) is not specified.\n');
            }

            return errorList;
        }
        //priority: 6
    });
}

function registerAppSettings() {
    exportImportDispatcher.register({
        ComponentExport: AppSettingsExportField,
        componentOptionsExport: {},
        ComponentImport: SettingsImport,
        id: 'appSettings',
        title: 'Application Settings',
        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                appSettings: {
                    keyList: options.keyListMarked
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.keyList == null || options.keyList.length === 0) {
                errorList.push(' - App Settings are not specified.\n');
            }

            return errorList;
        }
        //priority: 7
    });
}

function registerSqlTestCases() {
    exportImportDispatcher.register({
        ComponentExport: SqlTestCasesModelExport,
        componentOptionsExport: {},
        ComponentImport: SettingsImport,
        id: 'SQLTestCases',
        title: 'SQL Test Cases', // for selected Entity Models
        export: (options) => {
            if (options == null) {
                return null;
            }

            return {
                SQLTestCases: {
                    dataSources: options.dataSources
                }
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || options.keyList == undefined || options.keyList.length === 0) {
                errorList.push(' - SQL Test Cases is not specified.\n');
            }
            return errorList;
        }
        //priority: 8
    });
}

function registerUserGroups() {
    exportImportDispatcher.register({
        ComponentExport: UserGroupsExport,
        componentOptionsExport: {},
        ComponentImport: UserGroupsImport,
        id: 'groups',
        title: 'Groups and Users',
        export: (options: any) => {
            if (options == null) {
                return null;
            }

            return {
                groups: options
            };
        },

        import: (options: any) => {
            let errorList = [];

            if (options == null || Object.keys(options).length === 0) {
                errorList.push(' - Groups and Users are not specified.\n');
            }

            return errorList;
        }
        //priority: 5
    });
}

export function initExportImport(glob: IGlob) {
    registerEntityModels(glob);
    registerDataPermission(glob);
    registerWorkspaces(glob);
    registerThemes(glob);
    registerResources();
    registerTemplates();
    registerAppSettings();
    registerSqlTestCases();
    registerUserGroups();
}
